import _negate from 'lodash/negate';
import _isEmpty from 'lodash/isEmpty';

const notEmpty = _negate(_isEmpty);

export default notEmpty;
